module.exports = __webpack_public_path__ + "static/media/ruzhigaozhi.65e356b5.png";